import type { SVGProps } from 'react';

const SvgPlayerVolumeNo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15.87 11.91a1.002 1.002 0 0 0 .96-1.28 5.1 5.1 0 0 0-1.05-1.91 1 1 0 0 0-1.41-.1c-.42.36-.46 1-.1 1.41.3.34.52.73.64 1.16.13.44.53.72.96.72"
    />
    <path
      fill="currentcolor"
      d="M15.4 3.66a.998.998 0 1 0-.75 1.85A6.975 6.975 0 0 1 19.03 12c0 .58-.08 1.17-.25 1.81a.994.994 0 0 0 .97 1.25c.44 0 .85-.29.97-.74.22-.81.32-1.57.32-2.33 0-3.68-2.21-6.96-5.62-8.34zm2.98 13.29L5.72 4.29A.996.996 0 1 0 4.31 5.7l2.45 2.45-.73.85h-2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2l4.24 4.95c.6.71 1.76.28 1.76-.65v-5.87l4.18 4.18c-.48.36-.99.66-1.55.88a.996.996 0 0 0 .38 1.92c.12 0 .25-.02.38-.07.81-.33 1.55-.77 2.23-1.31l.68.67c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.34-1.34zM11.17 6.91a.5.5 0 0 0 .85-.35V4.7c0-.93-1.15-1.36-1.76-.65l-.6.7c-.17.2-.16.49.03.68z"
    />
  </svg>
);
export default SvgPlayerVolumeNo;
